import { useState, useEffect } from "react";
import FormData from "form-data";
import * as ReactBootStrap from "react-bootstrap";


import axios from "axios";

function VoterID() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    "Document Type": "",
    Voter_ID: "",
    Name: "",
    Gender: "",
    DOB: "",
    Year_of_Birth: "",
    Age: "",
    Address: "",
    District: "",
    State: "",
    Pin_Code: "",
    Father_Mother_Husband_Name: "",
  });
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)


  useEffect(() => {
    console.log(cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      "Document Type": "",
      Voter_ID: "",
      Father_Mother_Name: "",
      Gender: "",
      DOB: "",
      Year_of_Birth: "",
      Age: "",
      Address: "",
      District: "",
      State: "",
      Pin_Code: "",
      Father_Mother_Husband_Name: "",
      Status:""
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://w9et7fvjeg.execute-api.ap-south-1.amazonaws.com/default/VoterId_Ocr_Service",
      headers: {
        "x-api-key": "ndzCwJ4A681JCvpcUpnSR4PE8aTnPp2h301MNCLT",
        authorizationToken: "1c2j312ZOgLGJf4v",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true)
      })
      .catch(function (error) {
        setLoading(true)
        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div>
        <div class="container containerBoreder " id="pan">
          <h2 class="pageTitle">Voter ID OCR</h2>
          <div class="row">
            <div class="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div class="col-4">
              <button class="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
          <br />
          <table class="table">
            <tbody>
              <tr>
                <th width="25%">Documemt Type</th>
                <td>{cardData.Document_Type}</td>
              </tr>
              <tr>
                <th> Voter ID</th>
                <td>{cardData.Voter_ID}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{cardData.Status}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{cardData.Name}</td>
              </tr>
              <tr>
                <th>Father / Mother/ Husband Name</th>
                <td>{cardData.Father_Mother_Husband_Name}</td>
              </tr>
              <tr>
                <th>Gender </th>
                <td>{cardData.Gender}</td>
              </tr>
              <tr>
                <th>Age</th>
                <td>{cardData.Age} </td>
              </tr>
              <tr>
                <th>Address</th>
                <td>{cardData.Address}</td>
              </tr>
              <tr>
                <th>State</th>
                <td>{cardData.State}</td>
              </tr>
              <tr>
                <th>Pin_Code</th>
                <td>{cardData.Pin_Code} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default VoterID;
